<template>
    <section class="foot-menu">
        <bottom-select-menu :selectCurrent="current"
                            :tacticData="tacticData"
                            :quickData="quickData"
                            :infos="infos"
                            :isCaptain="isCaptain"
                            :captain="captain"
                            :myStatus="myStatus"
                            @afterTransitionEnd="afterLeave"
                            @close="closeMenu"
                            v-show="showMenu"
        ></bottom-select-menu>
        <ul class="footer-menu-ul">
            <li @click="selectItem(1)" :class="{'active': current == 1}">
                <i class="fa fa-flag"></i>
            </li>
            <li @click="selectItem(2)" :class="{'active': current == 2}">
                <i class="fa fa-retweet"></i>
            </li>
            <li @click="selectItem(3)" :class="{'active': current == 3}">
                <i class="fa fa-pencil-square"></i>
            </li>
            <li @click="selectItem(4)" :class="{'active': current == 4}">
                <i class="fa fa-comments"></i>
            </li>
        </ul>
    </section>
</template>

<script>
    import { getTactic, getQuicksay } from "@/api/get";
    import { STATUS } from "@/common/const";

    import BottomSelectMenu from '@/components/bottom-select-menu/bottom-select-menu';

    export default {
        name: "foot-menu",
        props: {
            infos: {
                type: Array,
                default() {
                    return [];
                }
            },
            tacticCurrent: {
                type: Number,
                default() {
                    return 0;
                }
            },
            captain: {
                type: String,
                default() {
                    return 'nobody'
                }
            },
            myStatus: {
                type: Number,
                default() {
                    return STATUS.outline
                }
            }
        },
        emits: ['select'],
        data() {
            return {
                // 当前选项卡点击的是哪一个
                current: 0,
                // 战术数据
                tacticData: {},
                quickData: {},
                showMenu: false
            }
        },
        computed: {
          isCaptain() {
              const myname = window.setting.userInfo.username;
              return this.captain == myname;
          }
        },
        methods: {
            afterLeave() {
                // 动画执行完毕的时候 查看selectedCurrent是否是1-4中的一个 是的话不能关闭
                const isShowing = [1, 2, 3, 4].includes(this.current);
                if (isShowing) {
                    return;
                }
                this.showMenu = false;
            },
            closeMenu() {
                this.current = 0;
            },
            selectItem(index) {
                this.showMenu = true;
                setTimeout(() => {
                    if (this.current == index) {
                        this.current = 0;
                        return;
                    }
                    this.current = index;
                    this.$emit('select', this.current);

                    switch (index) {
                        case 1:
                            this.getTacticData();
                            break;
                        case 4:
                            this.getQuicksay();
                            break;
                    }
                }, 20);

            },
            async getTacticData() {
                let tacticData = await getTactic(this.tacticCurrent);
                this.tacticData = tacticData;
            },
            async getQuicksay() {
                let quickData = await getQuicksay(this.tacticCurrent);
                this.quickData = quickData;
            }
        },
        watch: {
            tacticCurrent(newval, oldval) {
                if (newval != oldval) {
                    console.log('watching tacticCurrent');
                    this.getTacticData();
                    this.getQuicksay();
                }
            }
        },
        components: {
            BottomSelectMenu
        }
    }
</script>

<style scoped>
    .foot-menu {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        max-width: 640px;
        margin: 0 auto;
        background: #ffff;
        z-index: 10;
    }

    .foot-menu ul {
        display: flex;
        justify-content: space-between;
    }

    .foot-menu li {
        display: inline-block;
        text-align: center;
        flex: 1;
        font-size: 24px;
        line-height: 50px;
        height: 50px;
    }

    .foot-menu li:active {
        background-color: #f2f2f2;
    }

    .foot-menu li.active {
        color: #C4473D;
    }
</style>
